var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcEmptyContent',{staticClass:"empty-view",attrs:{"name":_vm.name,"description":_vm.description},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_vm._t("icon")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }